<template>
  <div class="as-incident-list as-d-flex as-flex-column" :class="[
    {
      'as-scrolling as-scrolling__result-popup': !isHomePage,
      'as-home-scrollable-content': isHomePage,
      'as-incident-list-sm': screenWidth < 375,
    },
    `as-parent-incident as-parent-incident-${siteName}`,
  ]">
    <div class="as-incident-list__content">
      <div class="as-incident-list__content-data">
        <div v-for="index in 10" :key="index" class="as-incident-list__event as-d-flex as-align-items-center">
          <div class="as-incident-list__event-time as-d-flex as-align-items-center">
            <SkeletonLoader width="30px" height="30px" :line="1" />
          </div>
          <div class="as-incident-list__event-detail as-d-flex as-flex-1" 
            :class="{
              'as-incident-list__event-detail--home': index % 2 === 0,
              'as-incident-list__event-detail--away': index % 2 !== 0,
            }"
          >
            <div class="as-incident-list__event-score as-d-flex as-flex-1">
              <SkeletonLoader width="100px" height="25px" :line="1" />
            </div>
            <div class="as-incident-list__event-icon as-d-flex justify-content-center as-align-items-center">
              <SkeletonLoader width="37px" height="37px" mode="circle" :line="1" />
            </div>
            <div class="as-incident-list__player as-d-flex as-flex-1">
              <div class="as-incident-list__player-name as-d-flex as-flex-column">
                <SkeletonLoader width="100px" height="25px" :line="1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

interface IProps {
  isHomePage?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);
</script>

<script lang="ts">
export default {};
</script>
